export const NAV_LINKS = [
  { label: 'Home', to: '/' },
  { label: 'Programs', to: '/programs' },
  { label: 'About', to: '/about' },
  { label: 'Faculty', to: '/faculty' },
  { label: 'Campus', to: '/campus' },
  { label: 'Sample Papers', to: '/resources' },
  { label: 'Admissions', to: '/admissions' },
];

export const PHONES = [
  { label: '99032-48390', value: '+919903248390' },
  { label: '97488-81508', value: '+919748881508' },
];

export const BRANCHES = [
  {
    name: 'Behala, Kolkata',
    address: '14 Panchanan Talya Lane, Behala, Kolkata, West Bengal',
    phone: '99032-48390',
    tel: '+919903248390',
    mapEmbed: 'https://maps.google.com/maps?q=22.5039866,88.3171552&z=17&output=embed',
    mapLink: 'https://www.google.com/maps/place/RN+academy/@22.5039866,88.3171552,17z/',
  },
  {
    name: 'Howrah',
    address: 'Saraswati Apartments, Howrah, West Bengal',
    phone: '97488-81508',
    tel: '+919748881508',
    mapEmbed: 'https://maps.google.com/maps?q=Saraswati+Apartments+Howrah&z=15&output=embed',
    mapLink: 'https://www.google.com/maps/search/Saraswati+Apartments+Howrah',
  },
];

export const PROGRAMS = [
  {
    icon: 'BookOpen',
    badge: 'Class 5 – 8',
    title: 'Foundation Program',
    tag: '',
    desc: 'Strong concept building in core subjects with a focus on clarity, discipline & study habits.',
    bullets: [
      'Strong concept building in core subjects',
      'Regular class tests & performance tracking',
      'Focus on clarity, discipline & study habits',
    ],
  },
  {
    icon: 'BookMarked',
    badge: 'Class 9 – 10',
    title: 'Secondary Program',
    tag: 'ICSE & CBSE',
    desc: 'Complete board-oriented preparation with mock tests and exam strategy guidance.',
    bullets: [
      'Complete syllabus coverage',
      'Board-oriented preparation',
      'Doubt-clearing sessions',
      'Mock tests & exam strategy guidance',
    ],
  },
  {
    icon: 'FlaskConical',
    badge: 'Class 11 – 12',
    title: 'Senior Secondary — Science',
    tag: 'Science Group',
    desc: 'Concept-based learning with numerical & application-focused practice and structured revision modules.',
    bullets: [
      'Concept-based learning',
      'Numerical & application-focused practice',
      'Structured revision modules',
    ],
  },
  {
    icon: 'Feather',
    badge: 'Class 11 – 12',
    title: 'Senior Secondary — Arts',
    tag: 'Arts Group',
    desc: 'Detailed theory preparation and answer-writing practice with board exam guidance. Special availability for Class 11–12 English Arts Group.',
    bullets: [
      'Detailed theory preparation',
      'Answer-writing practice',
      'Board exam guidance',
      'Special availability: Class 11–12 English',
    ],
  },
];

export const FACULTY = [
  {
    name: 'Mousumi Dutta',
    role: 'Arts Faculty Head',
    qual: 'M.Phil, MA English',
    bio: 'A literature scholar with deep expertise in English and the humanities. Mousumi mentors Arts Group students through detailed theory, answer-writing practice and board exam strategy.',
    initials: 'MD',
  },
  {
    name: 'Kanchan Sen',
    role: 'Managing Director – Science Faculty Head',
    qual: 'Senior Mentor, Science Group',
    bio: 'Leads RN Academy’s Science Group with structured revision modules, concept-based learning and numerical practice that has guided generations of students to top board results.',
    initials: 'KS',
  },
  {
    name: 'Kasturi Ghosh',
    role: 'Primary Faculty Head',
    qual: 'Foundation Program (Class 5–8)',
    bio: 'Builds the academic foundation of every RN Academy student — nurturing clarity in core subjects, study discipline and confidence from a young age.',
    initials: 'KG',
  },
];

export const TESTIMONIALS = [
  {
    quote: 'Moushumi Madam is a highly experienced and dedicated teacher. I had the opportunity to study under her for six years. She explains prose, poetry, and plays with great clarity and depth. In addition to English, she also teaches History and Geography very effectively. I am grateful for the strong foundation I built under her guidance.',
    name: 'Agnidipto Bhattacharya',
    sub: 'Alumni · Google Review',
  },
  {
    quote: 'Best teachers and mentors who ensure a strong foundation for English, History, Geography, Science and Maths. They care about their students and support them in achieving their full potential. I am privileged to be an alumni.',
    name: 'Prosari Banerjee',
    sub: 'Alumni · Google Review',
  },
  {
    quote: 'A good English teacher is not only a guide to language but also a source of inspiration. She teaches English language and literature with great clarity, patience and dedication.',
    name: 'Kamalika Bose',
    sub: 'Student · Google Review',
  },
  {
    quote: 'A very good tuition, takes good care of students who are weak and prepares very well for board exams.',
    name: 'Sreyashi Bhattacharya',
    sub: 'Student · Google Review',
  },
  {
    quote: 'They are the best teachers for Science, Math, English and Social Science.',
    name: 'Snigdha Das',
    sub: 'Student · Google Review',
  },
];

export const GOOGLE_REVIEW_URL = 'https://www.google.com/maps/place/RN+academy/@22.5039866,88.3171552,17z/';

export const FAQS = [
  {
    q: 'Which classes do you take admissions for?',
    a: 'RN Academy offers structured coaching for Class 5 to Class 12 across ICSE, CBSE & ISC boards. Both Science and Arts groups are available for Class 11–12.',
  },
  {
    q: 'Where are your branches located?',
    a: 'We have two branches — the main centre at 14 Panchanan Talya Lane, Behala, Kolkata and a second branch at Saraswati Apartments, Howrah.',
  },
  {
    q: 'Do you offer the English Arts Group for Class 11–12?',
    a: 'Yes. We offer special, focused batches for the Class 11–12 English Arts Group with detailed theory and answer-writing practice.',
  },
  {
    q: 'What is the batch size?',
    a: 'We deliberately keep batch sizes small so every student gets individual attention, regular doubt-clearing and personal mentoring.',
  },
  {
    q: 'When does the new academic session begin?',
    a: 'Admissions for the 2026–27 academic session are open now. Submit the admission form and our team will contact you within 24 hours.',
  },
];

export const RESOURCES = [
  { id: 'r1', title: 'ICSE Class 10 — Mathematics Sample Paper', board: 'ICSE', subject: 'Mathematics', type: 'Sample Paper', year: 2025, classLevel: 'Class 10' },
  { id: 'r2', title: 'CBSE Class 12 — Physics Question Paper', board: 'CBSE', subject: 'Physics', type: 'Question Paper', year: 2024, classLevel: 'Class 12' },
  { id: 'r3', title: 'ISC Class 12 — English Sample Paper', board: 'ISC', subject: 'English', type: 'Sample Paper', year: 2025, classLevel: 'Class 12' },
  { id: 'r4', title: 'CBSE Class 10 — Science Question Paper', board: 'CBSE', subject: 'Science', type: 'Question Paper', year: 2024, classLevel: 'Class 10' },
  { id: 'r5', title: 'ICSE Class 9 — History & Civics', board: 'ICSE', subject: 'History', type: 'Sample Paper', year: 2025, classLevel: 'Class 9' },
  { id: 'r6', title: 'ISC Class 11 — Chemistry Sample Paper', board: 'ISC', subject: 'Chemistry', type: 'Sample Paper', year: 2025, classLevel: 'Class 11' },
];

export const HERO_IMAGE = 'https://customer-assets.emergentagent.com/job_learning-hub-replica/artifacts/2qz9pawz_PHOTO-2026-02-16-11-30-20.jpg';
export const GROUP_IMAGE = 'https://customer-assets.emergentagent.com/job_learning-hub-replica/artifacts/20shx8cl_PHOTO-2026-02-18-13-57-48.jpg';
export const TEACHER_IMAGE = 'https://customer-assets.emergentagent.com/job_learning-hub-replica/artifacts/3tozdpw3_PHOTO-2026-02-18-13-57-50.jpg';
export const CERT_IMAGE = 'https://customer-assets.emergentagent.com/job_learning-hub-replica/artifacts/2qz9pawz_PHOTO-2026-02-16-11-30-20.jpg';
export const CLASSROOM_IMAGE = 'https://customer-assets.emergentagent.com/job_learning-hub-replica/artifacts/uqujiode_PHOTO-2026-02-18-13-57-51.jpg';
export const STUDENTS_HALLWAY_IMAGE = 'https://customer-assets.emergentagent.com/job_learning-hub-replica/artifacts/s5g0p24s_PHOTO-2026-02-18-13-57-48.jpg';
